<template>
  <client-only> <privacy-policy-content class="privacy-policy" /> </client-only>
</template>

<script>
export default {
  head() {
    return {
      title: 'Datenschutzerklärung',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: 'Datenschutzerklärung',
        },
      ],
    }
  },
}
</script>
